import { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const RouterContext = createContext();

const RouterContextProvider = ({ children }) => {
  const location = useLocation();
  const [route, setRoute] = useState({
    to: location,
    from: location,
  });

  useEffect(() => {
    setRoute(prev => ({ to: location, from: prev.to }));
  }, [location]);

  return (
    <RouterContext.Provider value={route}>{children}</RouterContext.Provider>
  );
};

export default RouterContextProvider;
